<template>
    <div>
        <vrm-header></vrm-header>
        <div class="container">
            <VrmPaygoClientInfo
                :installation="getInstallation()"
                :paygo-secrets="getPaygoSecrets()"
                :total-paid="totalPaid"
            />
            <VrmPaygoTokenGenerator
                :installation="getInstallation()"
                :paygo-secrets="getPaygoSecrets()"
                @updateTokenHistory="updateTokenHistory"
            />
            <VrmPaygoTokenHistory
                ref="history"
                :installation="getInstallation()"
                @updateTotalAmountSpend="updateTotalAmountSpend"
            />
        </div>
    </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularRoute, ngInject } from '@/vue/decorators/angular-interop';
import VrmHeader from '@/vue/components/layout/VrmHeader';
import VrmPaygoClientInfo from '@/vue/components/VrmPaygoClientInfo.vue';
import VrmPaygoTokenGenerator from '@/vue/components/VrmPaygoTokenGenerator.vue';
import VrmPaygoTokenHistory from '@/vue/components/VrmPaygoTokenHistory.vue';
@Component({
    components: { VrmHeader, VrmPaygoClientInfo, VrmPaygoTokenGenerator, VrmPaygoTokenHistory },
})
@AngularRoute('base.installation.paygo-admin', '/paygo-admin', { slot: 'body' })
export default class PaygoAdmin extends Vue {
    @ngInject()
    ApiService;
    @ngInject()
    InstallationsService;
    @ngInject()
    UserService;

    totalPaid = 0;

    async created() {
        try {
            this.loading = true;
        } finally {
            this.loading = false;
        }
        this.getPaygoSecrets();
    }

    getInstallation() {
        const idSite = this.$route.params.id;
        return this.InstallationsService.getInstallation(idSite);
    }

    getPaygoSecrets() {
        const idSite = this.$route.params.id;
        return this.ApiService.call(
            '/installations/' + idSite + '/paygo-secrets',
            {},
            'GET',
            false,
            'json',
            false,
        );
    }

    updateTokenHistory() {
        this.$refs.history.updateHistory();
    }

    updateTotalAmountSpend(totalPaid) {
        this.totalPaid = totalPaid;
    }
}
</script>
<style scoped>
.paygo-container {
    display: flex;
    justify-content: space-between;
}
</style>
